import type React from "react";
import { theme } from "../../theme";
import { useConsultantShell } from "./ConsultantShellContext";

/**
 * "My clients / Whole firm": which clients a workspace page leads with. Saved per
 * person on the server (backend lib/consultantPrefs.ts), so the sidebar badge and
 * every page follow the same choice. Filing, never access — a consultant can still
 * open any client of the firm.
 */
export function ScopeToggle({ compact = false }: { compact?: boolean }) {
  const { scope, setScope } = useConsultantShell();
  const pill = (active: boolean): React.CSSProperties => ({
    padding: compact ? "4px 10px" : "5px 12px", borderRadius: 3, fontSize: 12, fontWeight: 600, cursor: "pointer",
    fontFamily: theme.font,
    border: `1px solid ${active ? theme.color.accent : theme.color.border}`,
    background: active ? theme.color.accentBg : "transparent",
    color: active ? theme.color.accentText : theme.color.subtle,
  });
  return (
    <div role="group" aria-label="Which clients" style={{ display: "inline-flex", gap: 4 }}>
      <button type="button" aria-pressed={scope === "mine"} onClick={() => setScope("mine")} style={pill(scope === "mine")}
        title="Clients you are assigned to, plus any nobody is assigned to yet">
        My clients
      </button>
      <button type="button" aria-pressed={scope === "firm"} onClick={() => setScope("firm")} style={pill(scope === "firm")}>
        Whole firm
      </button>
    </div>
  );
}
